<template>
  <div class="bodyColor Page">
    <!--Banner-->
    <section class="">
        <div class="banner">
            <h1 class="PageTitle" style="">Service</h1>
        </div>
    </section>
    <!--after Sale Info-->
    <section id="afterSale">
      <v-row class="afterSaleBgV2">
        <v-col class="conainterafterSaleBgV2Info">
          <v-row>
            <v-col cols="12"> <h2 class="MontserratBI">notre département du service</h2></v-col>
            <v-col cols="12"><p>Le Réseau Dynamique : une équipe engagée au service de votre succès, depuis 50 ans. Nos <span class="bold">formateurs à temps plein</span> assurent que nos mécaniciens sont toujours parfaitement formés pour vous remettre rapidement sur la route, partout au Québec grâce à nos <span class="bold">22 points de service.</span></p></v-col>
          </v-row>
          <v-row>
            <v-col><router-link to="/nous-joindre"><button class="priBtn mt-5 flt-r" >Contactez-nous maintenant </button></router-link></v-col>
          </v-row>
        </v-col>
      </v-row>
    </section>
    <!--MY INTERNATIONAL-->
    <section id="serviceInt360">
      <v-row class="intBg">
        <v-col class="conainterInt360Info">
          <v-row>
            <v-col><img class="logoIntMax" src="../../public/ressources/images/services/MY_INTERNATIONAL_TM.png"  title="Logo MY INTERNATIONAL™ — gestion de flotte" alt="Logo MY INTERNATIONAL™ — plateforme de gestion de flotte camions" /></v-col>
          </v-row>
          <v-row style="">
            <v-col cols="12"><p class="bold">Révolutionnez votre entreprise avec la nouvelle plateforme My&nbsp;International™</p></v-col>
            <v-col cols="12"><p>My&nbsp;International™ est un écosystème numérique complet et connecté qui simplifie la gestion de votre flotte et votre collaboration avec notre réseau de concessionnaires. Que vous exploitiez un seul camion ou mille, nous vous fournissons les informations en temps réel et les outils de communication nécessaires pour réduire vos coûts, gagner du temps et optimiser la disponibilité de vos véhicules.</p></v-col>
          </v-row>
          <v-row>
            <v-col><a href="https://www.international.com/services/my-international" target="_blank"><button class="priBtn mt-5" >En savoir plus</button></a></v-col>
          </v-row>
          <v-row>
            <v-col><p class="engNote">(lien uniquement en anglais)</p></v-col>
          </v-row>

        </v-col>
      </v-row>
    </section>
    <!--On commande-->
    <section id="onCommand">
      <v-row class="onCommandBg">
        <v-col class="conainterOnCommandInfo">
          <v-row>
            <v-col><img class="logoOnCommand" src="../../public/ressources/images/logo/onCommand.png"  title="Logo OnCommand Connection — diagnostic à distance" alt="Logo OnCommand Connection — outil de diagnostic à distance pour flottes de camions" /></v-col>
          </v-row>
          <v-row>
            <v-col cols="12"><p>Profitez de l’outil de diagnostic à distance pour simplifier la gestion de votre flotte, tous modèles de camions confondus.</p></v-col>
            <v-col cols="12"><p>Disponible aussi sur l’application mobile OCCGO, accédez facilement à vos rapports de véhicules, codes d’erreur, inventaire de pièces et plus encore.</p></v-col>
          </v-row>
          <v-row>
            <v-col><a href="https://www.internationalusedtrucks.com/oncommand-connection/" target="_blank"><button class="priBtn mt-5 flt-r" >Découvrez-en plus</button></a></v-col>
          </v-row>
          
        </v-col>
      </v-row>
    </section>
    <!--Urgence routiere-->
    <section id="roadUrgency">
      <v-row class="roadUrgencyBG">
        <v-col class="conainterRoadUrgencyInfo">
          <v-row>
            <v-col><h2 class="TxtOffBDI">BESOIN D’UNE ASSISTANCE ROUTIÈRE ?</h2></v-col>
          </v-row>
          <v-row style="">
            <v-col cols="12"><p>Économisez temps et coûts grâce au service routier du Réseau Dynamique.</p></v-col>
            <v-col cols="12"><p>Nos techniciens certifiés remettent rapidement votre camion lourd en route avec un service fiable et sécuritaire. Si des réparations plus importantes sont nécessaires, votre camion et sa cargaison sont remorqués jusqu’à notre succursale la plus proche. Continuez vos activités grâce à notre service de location de camions pendant les réparations.</p></v-col>
          </v-row>
          <v-row>
            <v-col><router-link to="/urgenceRoutiere"><button class="priBtn mt-5" >RECEVOIR UNE ASSISTANCE</button></router-link></v-col>
          </v-row>
          
        </v-col>
      </v-row>
    </section>
    <!--all services-->
    <section id="allServices">
      <v-row class="allServicesBG">
        <v-col><h2>DÉCOUVREZ L’ENSEMBLE DE NOS SERVICES</h2></v-col>
      </v-row>
      <v-row>
          <v-col class="serviceSection bgparts">
            <router-link to="/piece"><h2 class="sectionTitle serviceSubtitle">PIÈCES</h2></router-link>
          </v-col>
          <v-col class="serviceSection bgSales" style="">
            <router-link to="/ventes"><h2 class="sectionTitle serviceSubtitle">Ventes</h2></router-link>
          </v-col>
          <v-col class="serviceSection bglocation" >
            <router-link to="/location"><h2 class="sectionTitle serviceSubtitle">LOCATION</h2></router-link>
          </v-col>
        </v-row>
    </section>
  </div>
</template>
<style scoped>
    .infoTitle { transition: opacity 0.1s ease-in-out; opacity: 1; }
    .infoTitle.change { opacity: 0.5; }
    .bodyColor { background-color: rgb(var(--ligthGray)); }
    .PageTitle { position: absolute; top: 50%; left: 50%; transform: translate(-50%,-50%); text-align: center; }
    .banner { position: relative; height: 400px; background-image: url('../../public/ressources/images/services/headerService.jpg'); background-position: center center; background-repeat: no-repeat; background-size: cover; }
    /*#region info Sale*/
      .afterSaleBg { min-height: 400px;  padding: 10px 0px; }
      .container { padding: 0px 5%; max-height: 450px; }
      .containerInfo { position: relative; padding: 50px; height: fit-content; max-width: 450px; margin: -25% 0px 0px 0px !important; background-color: rgb(var(--gray)); }
      .infoTitle { font-family: TxtOffBDI; color: rgb(var(--primary)); font-size: 78px; }
      .infoSubtitle { font-family: TxtOffBDI; text-transform: uppercase; color: white; font-size: 24px; min-width: 300px; text-align: center; padding: 20px 0px; }
      .infoText { font-family: TxtOffRe;  color: white; font-size: 24px; text-align: center;}
    /*#endregion*/
    /*#region After sale*/
      .afterSaleBgV2 { position: relative; height: 800px; width: 100%; margin-top: 40px !important; background-image: url('../../public/ressources/images/services/firstSection.jpg'); background-size: cover; background-position: center center; background-repeat: no-repeat; }
      .conainterafterSaleBgV2Info { position: absolute; right: 10%; top:20%; background-color: black; padding: 25px !important; max-width: 33%; }
      #afterSale h2 { color: white; text-align: right; text-transform: uppercase; }
      #afterSale p { color: white;  padding: 15px 0px; text-align: right; font-family: TxtOffRe; }
    /*#endregion*/
    /*#region International 360*/
      .intBg { position: relative; height: 800px; width: 100%; margin-top: 40px !important; background-image: url('../../public/ressources/images/services/International360BG.jpg'); background-size: cover; background-position: center center; background-repeat: no-repeat; }
      .conainterInt360Info { position: absolute; left: 10%; top:10%; background-color: black; padding: 25px !important; max-width: 33%; }
      #serviceInt360 p { color: white;  padding: 15px 0px; font-family: TxtOffRe; }
      .logoIntMax { max-width: 350px; }
      .engNote { font-size: 12px !important; padding: 0px !important; opacity: 0.8; }
    /*#endregion*/
    /*#region On commande*/
      .onCommandBg { position: relative; height: 800px; width: 100%; margin-top: 40px !important; background-image: url('../../public/ressources/images/services/onCommandBG.jpg'); background-size: cover; background-position: center center; background-repeat: no-repeat; }
      .logoOnCommand {  float: right; }
      .conainterOnCommandInfo { position: absolute; right: 10%; top:10%; background-color: black; padding: 25px !important; max-width: 33%; }
      #onCommand p { color: white;  padding: 15px 0px; text-align: right; font-family: TxtOffRe; }
    /*#endregion*/
    /*#region roadUrgency*/
      .roadUrgencyBG { margin-top: 40px !important; position: relative; height: 800px; width: 100%; background-image: url('../../public/ressources/images/services/roadUrgencyBG.jpg'); background-size: cover; background-position: center center; background-repeat: no-repeat; }
      .conainterRoadUrgencyInfo { position: absolute; left: 10%; top:10%; background-color: black; padding: 25px !important; max-width: 33%; }
      #roadUrgency h2 { color: white; }
      #roadUrgency p { color: white;  padding: 15px 0px; font-family: TxtOffRe; }
    /*#endregion*/
    /*#region promo*/
      .promoBG { margin-top: 40px !important; position: relative; height: 900px; width: 100%; background-image: url('../../public/ressources/images/services/promoBG.jpg'); background-size: cover; background-position: center center; background-repeat: no-repeat;  }
      .conainterpromoInfo { position: absolute; left: 50%; top:55%; transform: translate(-50%,-50%); padding: 25px !important; max-width: 33%; }
      .conainterpromoInfo h2 { text-align: center; color: white;  text-transform: uppercase; font-size: 36px; }
      .conainterpromoInfo p { text-align: center; color: white; padding: 30px 0px; font-size: 24px; font-family: TxtOffRe; }
      /*#endregion*/
    /*#region allServices*/
      .allServicesBG { background-color: rgb(var(--gray)); }
      .allServicesBG h2 { text-align: center; color: white; padding: 100px 0px; font-size: 36px; font-family: TxtOffBDI; }
      .bgSales { background-image: url('../../public/ressources/images/home/serviceSales.png'); background-position: center center; background-repeat: no-repeat; background-size: cover; }
      .bgparts { background-image: url('../../public/ressources/images/home/PIECES.png'); background-position: center center; background-repeat: no-repeat; background-size: cover; }
      .bgservice { background-image: url('../../public/ressources/images/home/SERVICE.png'); background-position: center center; background-repeat: no-repeat; background-size: cover; }
      .bglocation { background-image: url('../../public/ressources/images/home/LOCATION.png'); background-position: center center; background-repeat: no-repeat; background-size: cover; }
      .serviceTitle { font-family: TxtOffBDI; padding: 10% 0px; text-align: center; margin: 10px 0px !important; text-transform: uppercase; color: white; }
      .serviceSubtitle { font-family: TxtOffBDI; padding: 30% 0px; text-align: center; margin: 10px 0px; text-transform: uppercase; color: white; }
      .serviceSection:hover  .serviceTitle {color: rgb(var(--primary)); cursor: pointer;}
      .serviceSection:hover  .serviceSubtitle {color: rgb(var(--primary)); cursor: pointer;}
    /*#endregion*/
    @media handheld, only screen and (max-width: 600px) {
      .afterSaleBg { padding: 0px; }
      .containerInfo { min-width: 100% !important; padding: 20px 0px; }
      .containerImg { max-width: 100% !important; min-width: 100%; }
      .frameImg { min-width: auto; height: auto; }
      .textAfterSale p { font-size: 12px; }
      .titleAfterSale { margin: 0px 0px !important;  }
      .contactBtn { padding: 0px 5%; }
      .conainterInt360Info  { max-width: 80% !important; }
      #serviceInt360 p { font-size: 12px !important; }
      .conainterOnCommandInfo { max-width: 80% !important; }
      #onCommand p { font-size: 12px !important; }
      .conainterRoadUrgencyInfo { max-width: 80% !important; }
      #roadUrgency h2 { font-size: 16px !important; }
      #roadUrgency p { font-size: 12px !important; }
      .conainterpromoInfo p { padding: 20px 0px; font-size: 12px !important; }
      .priBtn { font-size: 18px; }
      .conainterpromoInfo { position: absolute; left: 50%; top:40%; transform: translate(-50%,-50%); padding: 25px !important; max-width: 100%; }
      .promoBG { height: 400px;  }
      .bgparts { min-width: 100%; }
      .bgservice { min-width: 100%; }
      .bglocation { min-width: 100%; }
      .logoOnCommand {  float: right; max-width: 100%; }
    }
    @media handheld, only screen and (max-width: 960px) {
      .conainterInt360Info  { max-width: 50%; }
      #serviceInt360 p { font-size: 16px; }
      .conainterOnCommandInfo { max-width: 50%; }
      #onCommand p { font-size: 16px; }
      .conainterRoadUrgencyInfo { max-width: 50%; }
      #roadUrgency h2 { font-size: 24px; }
      #roadUrgency p { font-size: 16px; }
      .conainterpromoInfo p { padding: 20px 0px; font-size: 16px ; }

      .container { padding: 0px 25px; max-height: unset; }
      .containerInfo { width: 100%; min-width: 500px; max-width: 100%; margin: 20px 0px !important; }

      .titleAfterSale { font-size: 24px; margin: 40px 0px;  }
      .containerImg { max-width: unset; min-width: 100%; margin: auto; }
      .frameImg { position: relative; margin: 40px auto; top: 0px; left: 0px; }
      .containerInfoAfterSale { margin: 40px 0px !important; padding: 0px 25px; }

      .conainterafterSaleBgV2Info { right: 5%; max-width: 90%; }

    }
    @media handheld, only screen and (max-width: 1279px) {}
    @media handheld, only screen and (max-width: 1378px) {}
</style>
<script>

export default {
  name: 'Service',
  data:()=>({
    counterPro: 0,
    counterProOne: 0,
    counterProTwo: 0,
    animationDurationCount: 1000,
  }),
  mounted() {
    // Meta tags SEO
    document.title = 'Service et réparation camions lourds | 22 points de service au Québec — Réseau Dynamique';
    this.setMeta('description', 'Service après-vente, réparation et entretien de camions lourds International avec 22 points de service au Québec. Diagnostic à distance, assistance routière, International 360, OnCommand Connection. Réseau Dynamique.');
    this.setMeta('og:title', 'Service camions lourds | 22 points de service — Réseau Dynamique');
    this.setMeta('og:description', 'Réparation, entretien et assistance routière pour camions lourds International. 22 points de service au Québec, techniciens certifiés, diagnostic à distance.');
    this.setMeta('og:type', 'website');
    this.setMeta('og:url', 'https://reseaudynamique.com/services');
    this.setMeta('og:image', 'https://reseaudynamique.com/ressources/images/services/headerService.jpg');

    this.animateProCounter();
    this.animateProOneCounter();
    this.animateProTwoCounter();
  },
  methods:{
    /** Helper pour ajouter/mettre à jour les balises meta */
    setMeta(name, content) {
      const isOg = name.startsWith('og:');
      const attr = isOg ? 'property' : 'name';
      let el = document.querySelector(`meta[${attr}="${name}"]`);
      if (!el) {
        el = document.createElement('meta');
        el.setAttribute(attr, name);
        document.head.appendChild(el);
      }
      el.setAttribute('content', content);
    },
    animateProCounter() {
      const maxCount = 600;
      const duration = this.animationDurationCount; // Durée totale de l'animation en millisecondes
      const stepTime = Math.abs(Math.floor(duration / maxCount));

      let currentCount = 0;
      const timer = setInterval(() => {
        currentCount++;
        this.counterPro = currentCount;
        if(currentCount === maxCount) {
          clearInterval(timer);
        }
      }, stepTime);
    },
    animateProOneCounter() {
      const maxCount = 600;
      const duration = this.animationDurationCount; // Durée totale de l'animation en millisecondes
      const stepTime = Math.abs(Math.floor(duration / maxCount));

      let currentCount = 0;
      const timer = setInterval(() => {
        currentCount++;
        this.counterProOne = currentCount;
        if(currentCount === maxCount) {
          clearInterval(timer);
        }
      }, stepTime);
    },
    animateProTwoCounter() {
      const maxCount = 600;
      const duration = this.animationDurationCount; // Durée totale de l'animation en millisecondes
      const stepTime = Math.abs(Math.floor(duration / maxCount));

      let currentCount = 0;
      const timer = setInterval(() => {
        currentCount++;
        this.counterProTwo = currentCount;
        if(currentCount === maxCount) {
          clearInterval(timer);
        }
      }, stepTime);
    },
  },
  components: { }
}
</script>